import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";
import { customStyles } from "./DropDownStyles";

export default class CompanyDropDown extends React.Component {
  state = {
    options: []
  };

  componentDidMount() {
    if (this.props.initialOptions) {
      console.log(this.props.initialOptions);
      this.setState({
        options: this.props.initialOptions
      });
    }
    this.prefetchSelected();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.prefetchSelected();
    }
  }

  prefetchSelected = async () => {
    const { value } = this.props;
    if (!value) return;
    const { options } = this.state;
    if (options.some(o => o.value == value)) return;
    try {
      const records = await fetchJson("/crm_api/company_search_by_id", { id: value });
      const fetched = (records || []).map(m => ({ label: m.name, value: m.id }));
      if (fetched.length > 0) {
        this.setState({ options: [...options, ...fetched] });
      }
    } catch (e) {
      // ignore
    }
  };

  fetchData = search => {
    return fetchJson("/crm_api/company_search.json", { search }).then(records => {
      var options = records.map(m => ({ label: m.name, value: m.id }));
      this.setState({ options });
      return options;
    });
  };

  onChange = dropDownItem =>
    this.props.onChange(dropDownItem ? dropDownItem.value : undefined);

  render() {
    const { value } = this.props;
    const { options } = this.state;
    const selectedValue = value ? options.filter(o => o.value == value) : undefined;
    return (
      <AsyncSelect
        value={selectedValue}
        placeholder={"Find Company"}
        isMulti={false}
        simpleValue={true}
        autoload={true}
        styles={customStyles()}
        id="suite_id"
        loadOptions={this.fetchData}
        onChange={this.onChange}
        isClearable={true}
      />
    );
  }
}
